type SponsorshipBranding = {
  enabled?: boolean;
  logoUrl?: string;
  name?: string | null;
};

type sessionsMenuProps = {
  menu: any[];
  sponsorshipBranding?: SponsorshipBranding | null;
};

export default function SessionsMenu({
  menu,
  sponsorshipBranding,
}: sessionsMenuProps) {
  const logoUrl = sponsorshipBranding?.logoUrl || "";
  const showLogo = !!sponsorshipBranding?.enabled && logoUrl.length > 0;

  return (
    <div className="">
      <div className="rounded-lg w-fit h-fit overflow-hidden">
        <div className="p-0 sm:flex-col flex gap-[1px]">
          {showLogo && (
            <div className="h-14 min-w-[92px] max-w-[150px] px-2 bg-white flex justify-center items-center">
              <img
                src={logoUrl}
                alt={sponsorshipBranding?.name || "Sponsor logo"}
                title={sponsorshipBranding?.name || "Sponsor"}
                className="max-h-10 max-w-[130px] object-contain"
              />
            </div>
          )}

          {!!menu &&
            menu.map((item, index) => {
              return (
                <button
                  key={index}
                  onClick={() => item.action()}
                  className={`w-14 h-14 bg-${item.color} text-center flex justify-center items-center`}
                >
                  <item.Icon className={`h-6 w-6 text-${item.iconColor}`} />
                </button>
              );
            })}
        </div>
      </div>
    </div>
  );
}